import React, { Component, createRef } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getContentOfferPageAccept, getOfferDetails, getCourseDetails, getSonePersonalDetails, putOfferAcceptance } from '../../services/vu'
import { getCourseId, setCourseId } from '../../helpers/course'
import HelpText from '../tags/HelpText'
import { getTooltipsForPage } from '../../services/reservoir'
import { ExpandableRadioButton, ExpandableRadioGroup } from '../tags/ExpandableRadioGroup'
import parse from 'html-react-parser';
import { getAttributeFromOfferStaticInfo, getOfferApplicationId, getOfferApplicationLineId, getOfferStaticInfoCache, offerStaticInfoCache } from '../../helpers/offer'
import { getConfiguration } from '../../helpers/configuration'
import Loading from '../tags/Loading'
import { courseStaticInfoCache } from '../../helpers/enrolment'
import OfferHeader from '../tags/OfferHeader'
import { FormControl, MenuItem, Select } from '@mui/material'

const mapStateToProps = ({courses: {courseCode, data}}) => {
  return {
    courseCode: courseCode,
    course: data[courseCode]
  }
}

class AcceptOffer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      drupalError: false,
      name: '',
      school: '',
      location: '',
      courseId: '',
      courseAttemptStatus: '',
      courseSPKNo: '',
      courseYear: '',
      studyPeriodDesc: '',
      attemptedToSubmit: false,
      submitting: false,
      tooltips: [],
      offerPageInformation: [],
      selectedResponseOption: 'Accept',
      selectedDeferOption: '',
      selectedDeclineOfferReason: '',
      hasSubmittedOffer: false,
      errors: {},
      headerTitle: 'START YOUR JOURNEY AT VU'
    }

    this.declineReasonsRef = createRef();

  }
  componentDidMount() {
    Promise.all([getSonePersonalDetails(), getTooltipsForPage('Accept Offer'), getContentOfferPageAccept(getAttributeFromOfferStaticInfo('courseExpectedStartDate'))])
      .then(([personalDetails, tooltips, offerPageInformation]) => {
        let studentName = personalDetails.preferredName || personalDetails.chosenFirstName || personalDetails.legalFirstName

        this.setState({
          loading: false,
          name: studentName,
          school: getAttributeFromOfferStaticInfo('courseTitle'),
          courseId: getAttributeFromOfferStaticInfo('courseCode'),
          location: getAttributeFromOfferStaticInfo('courseLocationDescription'),
          courseSPKNo: getAttributeFromOfferStaticInfo('courseSPK'),
          courseYear: getAttributeFromOfferStaticInfo('courseYear'),
          studyPeriodDesc: getAttributeFromOfferStaticInfo('courseStudyPeriodDescription'),
          tooltips: tooltips.data,
          offerPageInformation: offerPageInformation,
          selectedDeferOption: offerPageInformation.deferralPeriods.defaultPeriod,
          hasSubmittedOffer: getAttributeFromOfferStaticInfo('outcomeCode') !== 'NA'
        })
      })
      .catch(error => {
        if (error.response && error.response.status === 500) {
          this.setState({
            loading: false,
            drupalError: true
          })
        } else {
          this.setState({
            loading: false,
            error: true
          })
        }
      })
  }

  handleFormSubmit = event => {
    event.preventDefault()

    let offerApplicationId = getOfferApplicationId()

    let submissionDetails = {
      outcomeCode: this.state.selectedResponseOption,
      applicationId: offerApplicationId,
      courseCode: getAttributeFromOfferStaticInfo('courseCode'),
      courseSPKVersion: getAttributeFromOfferStaticInfo('courseSPKVersion')
    }

    let error = false

    switch (this.state.selectedResponseOption) {
      case 'Accept':
        this.setState({headerTitle: 'Congratulations!'})
        submissionDetails = {
          ...submissionDetails
        }
        break
      case 'Defer':
        let deferYear =
          parseInt(getAttributeFromOfferStaticInfo('courseYear')) +
          (this.state.offerPageInformation.deferralPeriods.periods.filter(period => period.code === this.state.selectedDeferOption).map(period => period.increaseCourseYear)[0] ? 1 : 0)

        let period = this.state.offerPageInformation.deferralPeriods.periods.filter(period => period.code === this.state.selectedDeferOption)[0]

        submissionDetails = {
          ...submissionDetails,
          notes: period.notes,
          courseYear: deferYear,
          courseStudyPeriodCode: this.state.selectedDeferOption
        }
        this.setState({headerTitle: 'See you soon!'})
        break
      case 'Decline':
        if (this.state.selectedDeclineOfferReason) {
          submissionDetails = {
            ...submissionDetails,
            status: this.state.selectedDeclineOfferReason
          }
        } else {
          error = true
          this.setState({
            errors: {
              declineReasonsSelect: ['Please select a reason for declining your offer.']
            }
          })
        }
        this.setState({headerTitle: 'Sorry to see you go!'})
        break
      default:
        break
    }

    if (!error) {
      this.setState({
        submitting: true
      })

      putOfferAcceptance(submissionDetails)
        .then(putResponse => {
          let success = putResponse.successful

          let offer = getOfferStaticInfoCache()
          offer.outcomeCode = submissionDetails.outcomeCode
          if (this.state.selectedResponseOption === 'Defer') {
            offer.deferStudyPeriodCode = this.state.selectedDeferOption
          }

          offerStaticInfoCache(offer, getOfferApplicationId())

          let courseId = getAttributeFromOfferStaticInfo('courseCode')
          setCourseId(courseId)

          this.setState({
            submitting: false,
            hasSubmittedOffer: success,
            errors: {}
          })
        })
        .catch(({ response: { status } }) => {
          if (status !== 504) {
            this.setState({headerTitle: 'Something went wrong!', error: true})
            //this.handleErrorSubmission('An error occurred while trying to update your offer. \n' + 'Please try again. If the problem persists, contact VUHQ for assistance.')
          }

          this.handleStudentOneTimeout(status === 504)
        })
    }
  }

  handleStudentOneTimeout = isStudentOneTimeout => {
    let offerApplicationId = getOfferApplicationId()
    let offerApplicationLineId = getOfferApplicationLineId()

    getOfferDetails(offerApplicationId, offerApplicationLineId, '')
      .then(offers => {
        let offer = offers[0]
        offerStaticInfoCache(offer, offerApplicationId)
        if (getAttributeFromOfferStaticInfo('outcomeCode') === 'NA' && isStudentOneTimeout) {
          this.scheduleStudentOneTimeoutCall(isStudentOneTimeout)
        } else {
          this.getCourseDetails()
        }
      })
      .catch(response => {
        this.stopLoading({
          submitting: false,
          errors: {}
        })
      })
  }

  scheduleStudentOneTimeoutCall = isStudentOneTimeout => {
    setTimeout(() => {
      this.handleStudentOneTimeout(isStudentOneTimeout)
    }, 30000)
  }

  getCourseDetails = () => {
    let courseId = getCourseId()
    let queryParams = {};
    queryParams['attemptNumber'] = this.props.course.attemptNumber;
    queryParams['versionNumber'] = this.props.course.versionNumber;
    queryParams["courseSSPNo"] = this.props.course.parentSSPNo
    queryParams['parentSSPNo'] = this.props.course.parentSSPNo;

    getCourseDetails(this.props.courseCode, queryParams)
      .then(course => {
        if (!course.isStudyPlanExpanded) {
          this.scheduleCourseDetailsCall()
        } else {
          courseStaticInfoCache(course, courseId, false)
          this.stopLoading({
            submitting: false,
            hasSubmittedOffer: getAttributeFromOfferStaticInfo('outcomeCode') !== 'NA',
            errors: {}
          })
        }
      })
      .catch(error => {
        this.stopLoading({
          error: true,
          errors: {}
        })
      })
  }

  scheduleCourseDetailsCall = () => {
    setTimeout(() => {
      this.getCourseDetails()
    }, 30000)
  }

  handleErrorSubmission = errorText => {
    alert(errorText)
  }

  handleDeclineReason = event => {
    this.setState({
      selectedDeclineOfferReason: event.target.value
    })
  }

  handleDeferRadioButtonClicked = (event, selectedDeferOption) => {
    event.preventDefault()
    this.setState({
      selectedDeferOption: selectedDeferOption
    })
  }

  handleRadioButtonClicked = (event, selectedResponseOption) => {
    event.preventDefault()
    this.setState({
      selectedResponseOption: selectedResponseOption
    })
  }

  getInformationPanel = radioOption => {
    return this.state.offerPageInformation.informationPanels
      .filter(offerResponse => offerResponse.code.toLowerCase().startsWith(radioOption.toLowerCase()))
      .map(offerResponse => offerResponse.panel.value)[0]
  }

  getDeclineReasons = () => {
    return this.state.offerPageInformation.declineOfferReasons.map(
      response => ({
        value: response.code,
        label: response.name
      })
    )
  }

  stopLoading = (newState = {}) => {
    this.setState({
      loading: false,
      ...newState
    })
  }

  generateMessageDiv = (message = 'Your response has been successfully updated, thank you. You will receive further information via email') => {
    return (
      <div className="row">
        <div className="col-xs-12">
          <div className="step-1">
            <p className="txt-lg">{message}</p>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return this.state.loading ? 
      <Loading /> : (
        <OfferHeader title={this.state.headerTitle}>
          {() => {
            if (this.state.drupalError) {
              this.handleErrorSubmission(
                'We seem to be having technical difficulties viewing your offer, please refresh your browser, and try again. If you continue to have difficulties, please contact VUHQ for assistance.'
              )
              return this.generateMessageDiv(
                'We seem to be having technical difficulties viewing your offer, please refresh your browser, and try again. If you continue to have difficulties, please contact VUHQ for assistance.'
              )
            }
        
            if (this.state.error) {
              //this.handleErrorSubmission('Unable to process offer acceptance, please contact VUHQ')
              return this.generateMessageDiv('An error occurred while trying to update your offer. \n' + 'Please try again. If the problem persists, contact VUHQ for assistance.')
            }
        
            if (this.state.hasSubmittedOffer) {
              return <Redirect to={{ pathname: getConfiguration('baseUrl') + '/offer/thankyou' }} />
            }
        
            if (this.state.submitting) {
              return (
                <div className="row">
                  <div className="col-xs-12">
                    <div className="step-1">
                      <p className="txt-lg">Thank you, {this.state.name}! Hold tight while we process your response - this may take a few minutes.</p>
                      <p className="txt-lg">If you're not redirected to the next page after three minutes, please refresh your browser.</p>
                    </div>
                  </div>
                </div>
              )
            }
        
            return (
              <form className="page page__offer_accept" onSubmit={this.handleFormSubmit}>
                <div className="step-1">
                  <p className="txt-lg" style={{paddingBottom: 20}}>
                    <span>{this.state.name}</span>, congratulations on your course offer! Confirm your place now in the following course:
                  </p>
                  <p className="txt-xl">
                    {this.state.school}
                    {this.state.courseId ? ` [${this.state.courseId}]` : null}
                  </p>
                  <p className="txt-lg">at</p>
                  <p className="txt-xl" style={{marginBottom: 0}}>
                    {this.state.location}
                  </p>
      
                  <p className="txt-md txt-light">(Your base campus)</p>
      
                  <p className="txt-lg">in</p>
                  <p className="txt-xl" style={{marginBottom: 0}}>
                    {this.state.courseYear} {this.state.studyPeriodDesc}
                  </p>
                </div>

                <div className='selection-container'>
                  <div>
                    <HelpText tag={'h3'} text={'Are you ready to start your course?'} />
                  </div>
        
                  <ExpandableRadioGroup customClass={'offer-radio'} name="offerAcceptance" onChange={this.handleRadioButtonClicked} valueSelected={this.state.selectedResponseOption}>
                    <ExpandableRadioButton label="Yes! I accept this offer" value={'Accept'}>
                      <div className="sub-options-container">{parse(this.getInformationPanel('Accept'))}</div>
                    </ExpandableRadioButton>
        
                    <ExpandableRadioButton label="I want to start later (defer my offer)" value={'Defer'}>
                      <div className="sub-options-container">
                        <p>How long would you like to defer starting your study for?</p>
        
                        <ExpandableRadioGroup name="offerAcceptance" onChange={this.handleDeferRadioButtonClicked} valueSelected={this.state.selectedDeferOption}>
                          {this.state.offerPageInformation.deferralPeriods.periods.map(period => {
                            return <ExpandableRadioButton key={period.code} label={period.display} value={period.code} />
                          })}
                        </ExpandableRadioGroup>
                        <div className="opt-msg">{parse(this.getInformationPanel('Defer'))}</div>
                      </div>
                    </ExpandableRadioButton>
        
                    <ExpandableRadioButton label="No, I decline this offer" value={'Decline'}>
                      <div className="sub-options-container">
                        <div className="row">
                          <div className="col-xs-12 col-md col-md-35">
                            <p>Please let us know your reason for declining your offer</p>
                          </div>
                          <div className="col-xs-12 col-md col-md-65">
                            <FormControl variant='standard' fullWidth>
                              <Select
                                ref={this.declineReasonsRef}
                                name="declineReasonsSelect"
                                value={this.state.selectedDeclineOfferReason}
                                onChange={this.handleDeclineReason}
                                options={this.getDeclineReasons()}
                              >
                                { this.getDeclineReasons().length && this.getDeclineReasons().map(
                                  reason => <MenuItem key={reason.value} value={reason.value}>{reason.label}</MenuItem>)
                                } 
                              </Select>  
                            </FormControl>
                            
                            {this.state.errors && this.state.errors.declineReasonsSelect && this.state.errors.declineReasonsSelect.length > 0 ? 
                            (<div className="form-error">{this.state.errors.declineReasonsSelect[0]}</div>) : null}
                            
                          </div>
                        </div>
                        <div className="opt-msg">{parse(this.getInformationPanel('Decline'))}</div>
                      </div>
                    </ExpandableRadioButton>
                  </ExpandableRadioGroup>
                </div>
                      
                
      
                <div className="row container-btn-submit-offer">
                  <div className="col-xs-12 col-sm-offset-3 col-sm-6 p-2">
                    <button className="btn btn-lg btn-primary enrol-start" type="submit" disabled={this.state.submitting}>
                      {this.state.submitting ? 'Submitting...' : 'Submit & Continue'}
                    </button>
                  </div>
                </div>
              </form>
            )
          }}
        </OfferHeader>
      )
   }
}

export default withRouter(connect(mapStateToProps)(AcceptOffer))
